module.exports = "/assets/data/6b711d3f77948e3b4fb63935194531af-ME17.data.json";